import {otpApi, REQUEST_OTP_CACHE_KEY, VERIFY_OTP_CACHE_KEY} from '.'

/** reusable selector for otp request result */
export const getRequestOtpResult = otpApi.endpoints.requestOtp.select(
  REQUEST_OTP_CACHE_KEY
)

/** reusable selector for verify otp result */
export const getVerifyOtpResult =
  otpApi.endpoints.verifyOtp.select(VERIFY_OTP_CACHE_KEY)
